"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
const date_1 = require("@powerednow/shared/modules/utilities/date");
let ActionEntity = class ActionEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], ActionEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: date_1.getNow })
], ActionEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true })
], ActionEntity.prototype, "job_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true })
], ActionEntity.prototype, "site_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: null, allowNull: true })
], ActionEntity.prototype, "user_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', allowNull: true })
], ActionEntity.prototype, "plot", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], ActionEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', fulltextSearchField: true })
], ActionEntity.prototype, "action", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], ActionEntity.prototype, "description", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], ActionEntity.prototype, "type", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], ActionEntity.prototype, "plan_type", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date' })
], ActionEntity.prototype, "dt_alert", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date' })
], ActionEntity.prototype, "dt_start", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date' })
], ActionEntity.prototype, "dt_end", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], ActionEntity.prototype, "is_open", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], ActionEntity.prototype, "linked_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], ActionEntity.prototype, "linked_type", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', codeName: 'isDeleted', serverOnly: true, defaultValue: false,
    })
], ActionEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], ActionEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isSent' })
], ActionEntity.prototype, "issent", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isNotToSend' })
], ActionEntity.prototype, "is_not_to_send", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], ActionEntity.prototype, "invite_customer", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', codeName: 'isArchived', serverOnly: true, defaultValue: false,
    })
], ActionEntity.prototype, "is_archived", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], ActionEntity.prototype, "dt_archived", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '7.5.0', type: 'int', allowNull: true })
], ActionEntity.prototype, "form_document_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], ActionEntity.prototype, "has_pending_checkin", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', minAppVersion: '8.0.4' })
], ActionEntity.prototype, "recurring_group_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '9.0.0' })
], ActionEntity.prototype, "duration_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '9.0.0' })
], ActionEntity.prototype, "appointmenttype_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '8.5.0' })
], ActionEntity.prototype, "status", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '8.5.0' })
], ActionEntity.prototype, "value", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '8.5.0' })
], ActionEntity.prototype, "is_pinned", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '8.5.0' })
], ActionEntity.prototype, "is_marked", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'int', minAppVersion: '8.5.7', serverOnly: true, defaultValue: null, allowNull: true,
    })
], ActionEntity.prototype, "expert_trades_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '9.0.0' })
], ActionEntity.prototype, "is_customer_booked", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', minAppVersion: '9.0.0' })
], ActionEntity.prototype, "dt_requested", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', minAppVersion: '9.0.0' })
], ActionEntity.prototype, "requested_duration_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '9.0.0', defaultValue: false })
], ActionEntity.prototype, "confirmed", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null, allowNull: true })
], ActionEntity.prototype, "what_three_words", void 0);
ActionEntity = __decorate([
    entity_1.EntityDecorator
], ActionEntity);
exports.default = ActionEntity;
//# sourceMappingURL=../../../../src/models/action/entity.js.map